import { APIData, appFetch } from ".";

export const jobsAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Job[]>>("/jobs?page=" + page);
  },
  submitJobApp(data: JobApplication) {
    return appFetch<APIData<{ message: string }>>("/submit-job-application", {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    });
  },
};
